import axios from "axios";

export default async function newForm(projectName, {form_name, description, form_type}) {
    const res  = await axios.patch(`/project/${projectName}/new-form`, {form_name, description, form_type})
    return res.data;
}